import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";

const Table = ({ ApiData }) => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  const getName = (item) => {
  return (
    <div className="flex flex-col">
      <span className="text-gray-800 font-semibold">
        {item.clientName}
      </span>
    </div>
  );
};
  const getCount=(item)=>{
    return(
      <div className="flex items-center">
        <span className="px-3 py-1 rounded-full bg-green-100 text-green-700 font-semibold text-xs">
          {item.selectedDateTenantCount}
        </span>
      </div>
    )
  }
  const getMonthCount=(item)=>{
    return(
      <div className="flex items-center">
        <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 font-semibold text-xs">
          {item.monthTenantCount}
        </span>
      </div>
    )
  }

  const getLastMonthCount=(item)=>{
    return(
      <div className="flex items-center">
        <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-700 font-semibold text-xs">
          {item.lastMonthTenantCount}
        </span>
      </div>
    )
  }


 
  useEffect(() => {
    if (ApiData) {
      setData(
        ApiData.map((item) => ({
          clientName: getName(item),
          selectedDateTenantCount: getCount(item),
          monthTenantCount: getMonthCount(item),
          lastMonthTenantCount: getLastMonthCount(item),
        }))
      );
    }
  }, [ApiData]);


  useEffect(() => {
    const handleResize = () =>
      setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () =>
      window.removeEventListener("resize", handleResize);
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        { Header: "Name", accessor: "clientName" },
        { Header: "Today Count", accessor: "selectedDateTenantCount" },
      ];
    }

    return [
      { Header: "Name", accessor: "clientName" },
      { Header: "Today Count", accessor: "selectedDateTenantCount" },
      { Header: "Monthly Count", accessor: "monthTenantCount" },
      { Header: "Last Month", accessor:"lastMonthTenantCount" }
    ];
  }, [isMobileView]); 

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    pageOptions,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: {
        pageIndex: currentPage,
        pageSize: PaginationLimit,
      },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          className={ApiData?.length > 0 ? "border-b" : ""}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps()}
                  className={ApiData?.length > 0 ? "border-b" : ""}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}>
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>

      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page <em>{pageIndex + 1} of {pageOptions.length}</em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={previousPage} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75" />
            </PrevBtn>
            <NextBtn onClick={nextPage} disabled={!canNextPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 rotate-180 opacity-75" />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table`w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(p) => (p.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(p) =>
  p.hasdata === "true" ? "border-b" : ""} hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500 cursor-pointer`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;

export default Table;


